module.exports = __webpack_public_path__ + "static/media/account_circle.13d7883d.svg";